import React from "react";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import SmartphoneIcon from "@mui/icons-material/SmartphoneOutlined";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import SmsIcon from "@mui/icons-material/SmsOutlined";
import FaxIcon from "@mui/icons-material/FaxOutlined";
import CallReceivedIcon from "@mui/icons-material/CallReceivedOutlined";
import ContactInfoCard from "./contactInfoCard";

// Details of a colleague from the internal directory.
const ContactInfoInternal = (props) => {
    const { open, setOpen, contact, onCall, onEmail } = props;

    if (!contact || !open)
        return null;

    // A directory entry may lack whole blocks; read them defensively.
    const extension = contact.voicemail?.mailbox;
    const name = `${contact.firstName || ""} ${contact.lastName || ""}`.trim();

    const sections = [
        {
            title: "Phone",
            rows: [
                { label: "Extension", value: extension, type: "phone", icon: <PhoneIcon /> },
                { label: "Mobile", value: contact.numbers?.mobile, type: "phone", icon: <SmartphoneIcon /> },
                { label: "Incoming number", value: contact.incomingProviderNumber?.number, type: "phone", icon: <CallReceivedIcon /> },
                { label: "SMS", value: contact.conversation?.number, type: "phone", noCall: true, icon: <SmsIcon /> },
                { label: "Fax", value: contact.fax?.number, type: "phone", noCall: true, icon: <FaxIcon /> },
            ],
        },
        {
            title: "Email",
            rows: [
                { label: "Email", value: contact.email, type: "email", icon: <EmailIcon /> },
            ],
        },
    ];

    return (
        <ContactInfoCard
            open={open}
            onClose={() => setOpen(false)}
            name={name}
            subtitle={extension ? `Internal contact · Ext. ${extension}` : "Internal contact"}
            number={extension}
            image={contact.profileImage}
            sections={sections}
            callNumber={extension || contact.numbers?.mobile}
            onCall={onCall ? (number) => onCall(contact, number) : undefined}
            email={contact.email}
            onEmail={onEmail}
        />
    );
}

export default ContactInfoInternal;
